import { render, staticRenderFns } from "./TherapistDashScheduleNew.vue?vue&type=template&id=c52c7dfa&scoped=true"
import script from "./TherapistDashScheduleNew.vue?vue&type=script&lang=js"
export * from "./TherapistDashScheduleNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52c7dfa",
  null
  
)

export default component.exports